'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var styledSystem = require('styled-system');
var dotGet = require('../utils/dotGet.js');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var custom = styledSystem.system({
  textTransform: true,
  transform: true,
  whiteSpace: true,
  cursor: true,
  backgroundColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  bgColor: {
    property: 'backgroundColor',
    scale: 'colors'
  },
  textDecoration: true,
  size: false
});
/**
 * UI's core style config. Allows a styled-component
 * to be customisable at prop, theme, component and
 * variant level. This function styled-system's
 * low level APIs to achieve this.
 *
 *
 * ORDER OF SPECIFICITY (Increasing Order)
 *
 * - Theme (styled-component's ThemeProvider)
 * - Theme variant
 * - Component size
 * - Function parameter
 * - Prop
 *
 * @param {object} config
 */

var styleEngine = function styleEngine(config) {
  return function (props) {
    var _dotGet, _dotGet$variants, _dotGet2, _dotGet2$sizes;

    /**
     * If a component is to be customized using
     * styled-component's ThemeProvider,
     * the component styled should be available
     * in the theme,`_component` should be passed
     * in order to find the style.
     *
     * Example -
     *
     * If a button component is to be customised
     * according to theme, "_component" should be
     * "button" (or any key) and that same key
     * should be available in the theme along
     * with any and all supported variants.
     */
    var _component = props._component,
        variant = props.variant,
        size = props.size; // if (_component === 'text') {
    //   console.log({
    //     ...(props.theme[_component] || {}),
    //     ...(props.theme[_component]?.variants?.[variant] || {}),
    //     ...(props.theme[_component]?.sizes?.[size] || {}),
    //     ...config,
    //     ...props,
    //   })
    // }

    return styled.css(["", ""], styledSystem.compose(styledSystem.space, styledSystem.color, styledSystem.typography, styledSystem.layout, styledSystem.flexbox, styledSystem.grid, styledSystem.background, styledSystem.border, styledSystem.position, styledSystem.shadow, custom)(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, dotGet['default'](props.theme, _component) || {}), ((_dotGet = dotGet['default'](props.theme, _component)) === null || _dotGet === void 0 ? void 0 : (_dotGet$variants = _dotGet.variants) === null || _dotGet$variants === void 0 ? void 0 : _dotGet$variants[variant]) || {}), ((_dotGet2 = dotGet['default'](props.theme, _component)) === null || _dotGet2 === void 0 ? void 0 : (_dotGet2$sizes = _dotGet2.sizes) === null || _dotGet2$sizes === void 0 ? void 0 : _dotGet2$sizes[size]) || {}), config), props)));
  };
};

exports.styleEngine = styleEngine;
